module.exports = __webpack_public_path__ + "img/symphony_675_electric.b06ec753.jpg";